export default class HeadersState {
  'x-lovepopid' = String
  'authorization' = String
}
